// @ts-nocheck
import { createI18n } from "vue-i18n";

import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from "@/const/trans";
import en from "@/lang/en.json";
import es from "@/lang/es.json";
import pt from "@/lang/pt.json";

const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('app-language') : null;

export default createI18n({
  // set locale
  locale: savedLang || DEFAULT_LANGUAGE,
  fallbackLocale: FALLBACK_LANGUAGE,

  // set locale messages
  messages: { en, es, pt },
  
  // Vue 3 compatibility
  legacy: false,
  globalInjection: true
});
